import { useLayoutEffect, useState } from "react";
import debounce from "lodash.debounce";

export const useIsMobile = (width: number) => {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window !== "undefined") {
            return window.innerWidth <= width;
        }
        return false;
    });

    useLayoutEffect(() => {
        const handleResize = debounce(() => {
            setIsMobile(window.innerWidth <= width);
        }, 200);

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            handleResize.cancel();
        };
    }, [width]);

    return isMobile;
};
